import Sdk from "casdoor-js-sdk";

const sdkConfig = {
  serverUrl: process.env.REACT_APP_CASDOOR_URI || "",
  clientId: process.env.REACT_APP_CASDOOR_ID || "",
  appName: "staff-desk-app",
  organizationName: "samokat",
  redirectPath: "/callback",
  signinPath: "/api/signin",
};

export const CasdoorSDK = new Sdk(sdkConfig);
